import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

/**
 * Standardized API Response Interface
 */
export interface ApiResponse<T = any> {
  success: boolean;
  statusCode: number;
  message: string;
  data: T | null;
  errors?: any;
}

/**
 * HTTP Response Interceptor
 * Transforms all API responses to standardized format
 */
@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        // Handle successful HTTP responses
        if (event instanceof HttpResponse) {
          const body = event.body;
          
          // Check if response already follows standardized format
          if (body && typeof body === 'object' && 'success' in body && 'statusCode' in body && 'message' in body) {
            // Response is already standardized
            return event.clone({ body });
          } else {
            // Transform legacy response to standardized format
            const standardizedResponse: ApiResponse = {
              success: true,
              statusCode: event.status,
              message: 'Success',
              data: body
            };
            return event.clone({ body: standardizedResponse });
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        let errorResponse: ApiResponse;
        
        if (error.error instanceof ErrorEvent) {
          // Client-side error
          errorResponse = {
            success: false,
            statusCode: 0,
            message: error.error.message || 'Network error occurred',
            data: null,
            errors: error.error
          };
        } else {
          // Server-side error
          const errorBody = error.error;
          
          // Check if error response already follows standardized format
          if (errorBody && typeof errorBody === 'object' && 'success' in errorBody && 'statusCode' in errorBody && 'message' in errorBody) {
            // Error is already standardized
            errorResponse = errorBody;
          } else {
            // Transform legacy error to standardized format
            errorResponse = {
              success: false,
              statusCode: error.status || 500,
              message: errorBody?.message || error.message || 'An error occurred',
              data: null,
              errors: errorBody?.errors || errorBody
            };
          }
        }
        
        // Return standardized error response
        return throwError(() => errorResponse);
      })
    );
  }
}





